import { useState, useEffect } from "react";
import axios from "axios";
import Header from "../components/Header";
import TabButton from "../components/TabButton";
import Card from "../components/Card";
import BlueButton from "../components/BlueButton";
import SimpleTable from "../components/SimpleTable";
import Badge from "../components/Badge";
import Select from "react-select";
import { useLocation } from "react-router-dom";
import Swal from "sweetalert2";
import { KeyRound, Download, FileText, Wallet } from "lucide-react";
import PullBackFlow from "./PullBackFlow";
import { formatDateTime } from "../components/formatDateTime";

export default function Keys() {
  const location = useLocation();

  const [tab, setTab] = useState("assign");
  const [keyType, setKeyType] = useState("Smart");
  const [packageType, setPackageType] = useState("");
  const [numKeys, setNumKeys] = useState("");
  const [keyRate, setKeyRate] = useState("");
  const [totalAmount, setTotalAmount] = useState("");
  const [selectedRetailer, setSelectedRetailer] = useState("");
  const [retailers, setRetailers] = useState([]);
  const [totalretailers, setTotalretailer] = useState([])
  const [packages, setPackages] = useState([]);
  const [agree, setAgree] = useState(false);

  const [assignedReports, setAssignedReports] = useState([]);
  const [loadingReport, setLoadingReport] = useState(false);
  const [errorReport, setErrorReport] = useState(null);

  const [pullbackReports, setPullbackReports] = useState([]);
  const [loadingpullbackReport, setLoadingPullbackReport] = useState(false);
  const [errorpullbackReport, setErrorPullbackReport] = useState(null);

  const [receivedReports, setReceivedReports] = useState([]);
  const [loadingReceive, setLoadingReceive] = useState(false);
  const [errorReceive, setErrorReceive] = useState(null);

  const [loadingBalance, setLoadingBalance] = useState(false);
  const [errorBalance, setErrorBalance] = useState(null);

  // Pagination states
  const [receivePage, setReceivePage] = useState(1);
  const [reportPage, setReportPage] = useState(1);
  const [reportpullbackPage, setReportPullbackPage] = useState(1);
  const [balancePage, setBalancePage] = useState(1);

  const [reportTotalPages, setReportTotalPages] = useState(1);
  const [reportpullbackTotalPages, setPullbackReportTotalPages] = useState(1);
  const [receiveTotalPages, setReceiveTotalPages] = useState(1);
  const [balanceTotalPages, setBalanceTotalPages] = useState(1);

  const rowsPerPage = 10;

  const authUserString = sessionStorage.getItem("authUserData");
  const authUser = JSON.parse(authUserString);
  const loginUserID = authUser?.id;
  const CompanyID = authUser?.company_id;

  useEffect(() => {
    if (location.state?.tab) setTab(location.state.tab);
  }, [location.state]);

  // =============================
  // 📦 Fetch 100 retailers for dropdown (Assign tab)
  // =============================
  useEffect(() => {
    if (!loginUserID) return;
    axios
      .get(
        `https://goelectronix.in/api/v1/get-allretailers2?page=1&per_page=100&distributortID=${loginUserID}`
      )
      .then((res) => {
        const data = res.data.data.data || [];
        setRetailers(data);
        setTotalretailer(res.data.data.total);
      })
      .catch((err) => console.error("Failed to load retailers:", err));
  }, [loginUserID]);

  // =============================
  // 📊 Fetch retailer balance list with pagination
  // =============================
  useEffect(() => {
    if (!loginUserID || tab !== "retailer-balance") return;

    const fetchRetailers = async () => {
      setLoadingBalance(true);
      setErrorBalance(null);
      try {
        const res = await axios.get(
          `https://goelectronix.in/api/v1/get-allretailers2?page=${balancePage}&per_page=${rowsPerPage}&distributortID=${loginUserID}`
        );

        const data = res.data.data.data || [];
        setRetailers(data);
        
        // setBalanceTotalPages(res.data.last_page || 1);
        setBalanceTotalPages(res.data.data.last_page || 1);
        console.log("API last page:", res.data.data.last_page);

      } catch (err) {
        console.error("Failed to fetch retailers:", err);
        setErrorBalance("Failed to load retailer balance");
      } finally {
        setLoadingBalance(false);
      }
    };

    fetchRetailers();
  }, [loginUserID, balancePage, tab]);

  // =============================
  // 📜 Fetch assigned reports
  // =============================
  useEffect(() => {
    if (tab !== "report") return;

    const fetchReports = async () => {
      setLoadingReport(true);
      setErrorReport(null);
      try {
        const res = await axios.get(
          `https://goelectronix.in/api/v1/keys/report?sender_id=${loginUserID}&mode=1&company_id=${CompanyID}&page=${reportPage}&per_page=${rowsPerPage}`
        );

        setAssignedReports(res.data.data || []);
        setReportTotalPages(res.data.last_page || 1);
      } catch (err) {
        console.error("Failed to fetch assigned reports:", err);
        setErrorReport("Failed to load report");
      } finally {
        setLoadingReport(false);
      }
    };

    fetchReports();
  }, [tab, loginUserID, CompanyID, reportPage]);

  useEffect(() => {
    if (tab !== "pullbackreport") return;

    const fetchPullbackReports = async () => {
      setLoadingPullbackReport(true);
      setErrorPullbackReport(null);
      try {
        const res = await axios.get(
          `https://goelectronix.in/api/v1/keys/report?receiver_id=${loginUserID}&mode=2&company_id=${CompanyID}&page=${reportPage}&per_page=${rowsPerPage}`
        );

        setPullbackReports(res.data.data || []);
        setPullbackReportTotalPages(res.data.last_page || 1);
      } catch (err) {
        console.error("Failed to fetch assigned reports:", err);
        setErrorPullbackReport("Failed to load report");
      } finally {
        setLoadingPullbackReport(false);
      }
    };

    fetchPullbackReports();
  }, [tab, loginUserID, CompanyID, reportPage]);

  // =============================
  // 📥 Fetch received reports
  // =============================
  useEffect(() => {
    if (tab !== "receive") return;

    const fetchReceiveReports = async () => {
      setLoadingReceive(true);
      setErrorReceive(null);
      try {
        const res = await axios.get(
          `https://goelectronix.in/api/v1/keys/report?receiver_id=${loginUserID}&mode=1&company_id=${CompanyID}&page=${receivePage}&per_page=${rowsPerPage}`
        );

        setReceivedReports(res.data.data || []);
        setReceiveTotalPages(res.data.last_page || 1);
      } catch (err) {
        console.error("Failed to fetch receive reports:", err);
        setErrorReceive("Failed to load receive report");
      } finally {
        setLoadingReceive(false);
      }
    };

    fetchReceiveReports();
  }, [tab, loginUserID, CompanyID, receivePage]);

  // =============================
  // 📦 Fetch packages
  // =============================
  useEffect(() => {
    if (!loginUserID) return;
    axios
      .get(
        `https://goelectronix.in/api/v1/keys/all-my-package-list?receiver_id=${loginUserID}`
      )
      .then((res) => setPackages(res.data.data || []))
      .catch((err) => console.error(err));
  }, [loginUserID]);

  // Auto calculate total
  useEffect(() => {
    const total = parseInt(numKeys || 0) * parseFloat(keyRate || 0);
    setTotalAmount(isNaN(total) ? "" : total.toFixed(2));
  }, [numKeys, keyRate]);

  // =============================
  // 🚀 Handle Assign
  // =============================
  const handleAssign = async () => {
    const selectedPkg = packages.find((pkg) => pkg.package_name === packageType);
    if (!selectedPkg) {
      Swal.fire("Error", "Please select a package", "error");
      return;
    }

    const selectedRetailerData = retailers.find((ret) => ret.ID === selectedRetailer);
    if (!selectedRetailerData) {
      Swal.fire("Error", "Please select a retailer", "error");
      return;
    }

    const payload = {
      sender_id: authUser?.id,
      sender_name: authUser?.business_name,
      sender_code: authUser?.org_code,
      receiver_name: selectedRetailerData.Shop_Name,
      receiver_code: selectedRetailerData.RetailerCode,
      receiver_id: selectedRetailerData.USerID,
      package_name: selectedPkg.package_name,
      key_rate: keyRate,
      qty: numKeys,
      amount: totalAmount,
      product_id: selectedPkg.product_id,
      key_type: selectedPkg.key_type,
      mode: 1,
      company_id: 5865,
      dist_id: authUser?.id,
      role: selectedRetailerData.Role,
      user_package_id: selectedPkg.id,
      created_by_id: authUser?.id,
      created_by_name: authUser?.business_name,
      created_by_code: authUser?.org_code,
      sender_package_id: selectedPkg.id,
      customer_id: selectedRetailerData.contact_id?.toString(),
      bill_type: "Rebilling",
      is_warranty: selectedPkg.is_warranty,
    };

    Swal.fire({
      title: `Assigning keys to ${selectedRetailerData.Shop_Name}...`,
      text: "Please wait",
      allowOutsideClick: false,
      didOpen: () => Swal.showLoading(),
    });

    try {
      await axios.post(
        "https://goelectronix.in/api/v1/keys/assign-without-zoho",
        payload
      );
      Swal.fire(
        "Success ✅",
        `Keys assigned successfully to ${selectedRetailerData.Shop_Name}`,
        "success"
      );

      setPackageType("");
      setNumKeys("");
      setKeyRate("");
      setTotalAmount("");
      setSelectedRetailer("");
      setAgree(false);
    } catch (err) {
      console.error(err);
      Swal.fire("Error ❌", "Failed to assign keys. Please try again.", "error");
    }
  };

  // Filter package list by keyType
  const filteredPackages = packages.filter((pkg) => {
    if (keyType === "Regular") return pkg.key_type === 1;
    if (keyType === "Smart") return pkg.key_type === 2;
    return false;
  });

  // =============================
  // 🧩 UI RENDER
  // =============================
  return (
    <div className="space-y-3 sm:space-y-4">
      <Header title="Keys">
        <div className="flex flex-wrap gap-2 text-xs sm:text-sm">
          <TabButton active={tab === "assign"} onClick={() => setTab("assign")} className="flex items-center gap-1">
            <KeyRound className="w-4 h-4 sm:hidden" />
            <span className="hidden sm:inline">Assign</span>
          </TabButton>

          <TabButton active={tab === "receive"} onClick={() => setTab("receive")} className="flex items-center gap-1">
            <Download className="w-4 h-4 sm:hidden" />
            <span className="hidden sm:inline">Receive</span>
          </TabButton>

          <TabButton active={tab === "report"} onClick={() => setTab("report")} className="flex items-center gap-1">
            <FileText className="w-4 h-4 sm:hidden" />
            <span className="hidden sm:inline">Assigned Report</span>
          </TabButton>

          <TabButton active={tab === "pullbackreport"} onClick={() => setTab("pullbackreport")} className="flex items-center gap-1">
            <FileText className="w-4 h-4 sm:hidden" />
            <span className="hidden sm:inline">Pullback Report</span>
          </TabButton>

          <TabButton active={tab === "retailer-balance"} onClick={() => setTab("retailer-balance")} className="flex items-center gap-1">
            <Wallet className="w-4 h-4 sm:hidden" />
            <span className="hidden sm:inline">Retailer Key Balance</span>
          </TabButton>

          <TabButton active={tab === "pullback"} onClick={() => setTab("pullback")} className="flex items-center gap-1">
            <Wallet className="w-4 h-4 sm:hidden" />
            <span className="hidden sm:inline">PullBack</span>
          </TabButton>
        </div>
      </Header>

      {/* ========================= Assign Keys ========================= */}
      {tab === "assign" && (
        <Card title="Assign Keys to Retailer">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            {/* Retailer Dropdown */}
            <Select
              options={retailers.map((ret) => ({
                value: ret.ID,
                label: `${ret.Shop_Name} - ${ret.RetailerCode}`,
              }))}
              value={
                retailers
                  .map((ret) => ({
                    value: ret.ID,
                    label: `${ret.Shop_Name} - ${ret.RetailerCode}`,
                  }))
                  .find((opt) => opt.value === selectedRetailer) || null
              }
              onChange={(option) => setSelectedRetailer(option?.value || "")}
             placeholder={`Select from ${totalretailers} Retailer... `}
              isClearable
            />

            {/* Key Type */}
            <select
              value={keyType}
              onChange={(e) => {
                setKeyType(e.target.value);
                setPackageType("");
              }}
              className="rounded-lg border px-3 py-2 text-sm"
            >
              <option value="Smart">Smart</option>
              <option value="Regular">Regular</option>
            </select>

            {/* Package Type */}
            <select
              value={packageType}
              onChange={(e) => setPackageType(e.target.value)}
              className="rounded-lg border px-3 py-2 text-sm"
            >
              <option value="">Select Package</option>
              {filteredPackages.map((pkg) => (
                <option key={pkg.id} value={pkg.package_name}>
                  {pkg.package_name} - {pkg.balance_keys}
                </option>
              ))}
            </select>

            {/* Number of Keys */}
            <input
              type="number"
              placeholder="Number of Keys"
              value={numKeys}
              onChange={(e) => {
                const value = parseInt(e.target.value || "0", 10);
                const selectedPkg = filteredPackages.find(
                  (pkg) => pkg.package_name === packageType
                );
                const maxAllowed = selectedPkg ? selectedPkg.balance_keys : Infinity;
                if (value <= maxAllowed) {
                  setNumKeys(e.target.value);
                } else {
                  setNumKeys(maxAllowed.toString());
                }
              }}
              className="rounded-lg border px-3 py-2 text-sm"
            />

            {/* Key Rate */}
            <input
              type="number"
              placeholder="Key Rate"
              value={keyRate}
              onChange={(e) => setKeyRate(e.target.value)}
              className="rounded-lg border px-3 py-2 text-sm"
            />

            {/* Total Amount */}
            <input
              type="text"
              placeholder="Total Amount"
              value={totalAmount}
              readOnly
              className="rounded-lg border px-3 py-2 text-sm bg-gray-100"
            />

            {/* Submit button */}
            <div className="sm:col-span-2 flex justify-end">
              <BlueButton onClick={handleAssign}>Assign</BlueButton>
            </div>
          </div>
        </Card>
      )}

      {/* ========================= Receive ========================= */}
      {tab === "receive" && (
        <Card title="Received Keys Report (From Company)">
          {loadingReceive ? (
            <p>Loading...</p>
          ) : errorReceive ? (
            <p className="text-red-500">{errorReceive}</p>
          ) : receivedReports.length === 0 ? (
            <p>No data found</p>
          ) : (
            <>
              <SimpleTable
                headers={["Sr No.", "Date", "Sender (Code)", "Type", "Package", "Count", "Status"]}
                rows={receivedReports.map((rep, i) => [
                  (receivePage - 1) * rowsPerPage + i + 1,
                  new Date(rep.created_at).toLocaleDateString(),
                  `${rep.sender_name} (${rep.sender_code || "N/A"})`,
                  rep.key_type === 1 ? "Regular" : "Smart",
                  rep.package_name,
                  rep.qty,
                  <Badge label="Received" color="blue" />,
                ])}
              />
              <div className="flex justify-center gap-2 mt-2">
                <button disabled={receivePage === 1} onClick={() => setReceivePage(receivePage - 1)} className="px-3 py-1 bg-gray-200 rounded disabled:opacity-50">
                  Prev
                </button>
                <span className="px-3 py-1">
                  {receivePage} / {receiveTotalPages}
                </span>
                <button
                  disabled={receivePage === receiveTotalPages}
                  onClick={() => setReceivePage(receivePage + 1)}
                  className="px-3 py-1 bg-gray-200 rounded disabled:opacity-50"
                >
                  Next
                </button>
              </div>
            </>
          )}
        </Card>
      )}

      {/* ========================= Report ========================= */}
      {tab === "report" && (
        <Card title="Assigned Keys Report">
          {loadingReport ? (
            <p>Loading...</p>
          ) : errorReport ? (
            <p className="text-red-500">{errorReport}</p>
          ) : assignedReports.length === 0 ? (
            <p>No data found</p>
          ) : (
            <>
              <SimpleTable
                headers={["Sr No.", "Date", "Retailer (Code)", "Type", "Package", "Count","Key rate", "Total Amount", "Status"]}
                rows={assignedReports.map((rep, i) => [
                  (reportPage - 1) * rowsPerPage + i + 1,
                  formatDateTime(rep.created_at),
                  `${rep.receiver_name} (${rep.receiver_code || "N/A"})`,
                  rep.key_type === 1 ? "Regular" : "Smart",
                  rep.package_name,
                  rep.qty,
                  ` ₹ ${rep.key_rate}`,
                  ` ₹ ${rep.amount}`,
                  <Badge label="Assigned" color="blue" />,
                ])}
              />
              <div className="flex justify-center gap-2 mt-2">
                <button disabled={reportPage === 1} onClick={() => setReportPage(reportPage - 1)}>
                  Prev
                </button>
                <span>
                  {reportPage}/{reportTotalPages}
                </span>
                <button disabled={reportPage === reportTotalPages} onClick={() => setReportPage(reportPage + 1)}>
                  Next
                </button>
              </div>
            </>
          )}
        </Card>
      )}

      {tab === "pullbackreport" && (
        <Card title="Pullback Keys Report">
          {loadingpullbackReport ? (
            <p>Loading...</p>
          ) : errorpullbackReport ? (
            <p className="text-red-500">{errorpullbackReport}</p>
          ) : pullbackReports.length === 0 ? (
            <p>No data found</p>
          ) : (
            <>
              <SimpleTable
                headers={["Sr No.", "Date", "Retailer (Code)", "Type", "Package", "Count", "Pullback By", "Key rate", "Total Amount","Status"]}
                rows={pullbackReports.map((rep, i) => [
                  (reportpullbackPage - 1) * rowsPerPage + i + 1,
                  formatDateTime(rep.created_at),
                  `${rep.sender_name} (${rep.sender_code || "N/A"})`,
                  rep.key_type === 1 ? "Regular" : "Smart",
                  rep.package_name,
                  rep.qty,
                  rep.created_by_name,
                  ` ₹ ${rep.key_rate}`,
                  ` ₹ ${rep.amount}`,
                  <Badge label="Pullbacked" color="blue" />,
                ])}
              />
              <div className="flex justify-center gap-2 mt-2">
                <button disabled={reportpullbackPage === 1} onClick={() => setReportPullbackPage(reportpullbackPage - 1)}>
                  Prev
                </button>
                <span>
                  {reportpullbackPage}/{reportpullbackTotalPages}
                </span>
                <button disabled={reportpullbackPage === reportpullbackTotalPages} onClick={() => setReportPullbackPage(reportpullbackPage + 1)}>
                  Next
                </button>
              </div>
            </>
          )}
        </Card>
      )}

      {/* ========================= Retailer Balance ========================= */}
      {tab === "retailer-balance" && (
        <Card title="Retailer Key Balance">
          {loadingBalance ? (
            <p>Loading...</p>
          ) : errorBalance ? (
            <p className="text-red-500">{errorBalance}</p>
          ) : retailers.length === 0 ? (
            <p>No data found</p>
          ) : (
            <>
              <SimpleTable
                headers={["Retailer (Code)", "Regular Keys", "Smart Keys", "Total"]}
                rows={retailers.map((ret) => {
                  const regular = parseInt(ret.regularPolicy || 0, 10);
                  const smart = parseInt(ret.smartPolicy || 0, 10);
                  const total = regular + smart;
                  return [
                    `${ret.Shop_Name} (${ret.RetailerCode})`,
                    regular,
                    smart,
                    total,
                  ];
                })}
              />
             <div className="flex justify-center gap-2 mt-4">
              <button
                disabled={balancePage === 1}
                onClick={() => setBalancePage(balancePage - 1)}
                className="px-3 py-1 rounded border"
              >
                Prev
              </button>
              <span>{balancePage} / {balanceTotalPages}</span>
              <button
                disabled={balancePage === balanceTotalPages}
                onClick={() => setBalancePage(balancePage + 1)}
                className="px-3 py-1 rounded border"
              >
                Next
              </button>
            </div>
            </>
          )}
        </Card>
      )}

      {tab === "pullback" && (
        <PullBackFlow/>
      )
      }
    </div>
  );
}


// import { useState, useEffect } from "react";
// import axios from "axios";
// import Header from "../components/Header";
// import TabButton from "../components/TabButton";
// import Card from "../components/Card";
// import BlueButton from "../components/BlueButton";
// import SimpleTable from "../components/SimpleTable";
// import Badge from "../components/Badge";
// import Select from "react-select";
// import { useLocation } from "react-router-dom";
// import Swal from "sweetalert2";
// import { KeyRound, Download, FileText, Wallet } from "lucide-react";

// export default function Keys() {
//   const location = useLocation();

//   const [tab, setTab] = useState("assign");
//   const [keyType, setKeyType] = useState("Smart");
//   const [packageType, setPackageType] = useState("");
//   const [numKeys, setNumKeys] = useState("");
//   const [keyRate, setKeyRate] = useState("");
//   const [totalAmount, setTotalAmount] = useState("");
//   const [selectedRetailer, setSelectedRetailer] = useState("");
//   const [retailers, setRetailers] = useState([]);
//   const [packages, setPackages] = useState([]);
//   const [agree, setAgree] = useState(false);

//   const [assignedReports, setAssignedReports] = useState([]);
//   const [loadingReport, setLoadingReport] = useState(false);
//   const [errorReport, setErrorReport] = useState(null);

//   const [receivedReports, setReceivedReports] = useState([]);
//   const [loadingReceive, setLoadingReceive] = useState(false);
//   const [errorReceive, setErrorReceive] = useState(null);


//   const [reportTotalPages, setReportTotalPages] = useState(1);
//   const [receiveTotalPages, setReceiveTotalPages] = useState(1);

//   // Pagination states
//   const [receivePage, setReceivePage] = useState(1);
//   const [reportPage, setReportPage] = useState(1);
//   const [balancePage, setBalancePage] = useState(1);
//   const rowsPerPage = 10;

//   const authUserString = sessionStorage.getItem("authUserData");
//   const authUser = JSON.parse(authUserString);
//   const loginUserID = authUser?.id;
//   const CompanyID = authUser?.company_id;

//   useEffect(() => {
//     if (location.state?.tab) setTab(location.state.tab);
//   }, [location.state]);

//   // Fetch assigned reports
//   useEffect(() => {
//   if (tab !== "report") return;

//   const fetchReports = async () => {
//     setLoadingReport(true);
//     setErrorReport(null);
//     try {
//       const res = await axios.get(
//         `https://goelectronix.in/api/v1/keys/report?sender_id=${loginUserID}&mode=1&company_id=${CompanyID}&page=${reportPage}&per_page=${rowsPerPage}`
//       );

//       setAssignedReports(res.data.data || []);
//       setReportTotalPages(res.data.meta?.last_page || 1); // backend pagination metadata
//     } catch (err) {
//       console.error("Failed to fetch assigned reports:", err);
//       setErrorReport("Failed to load report");
//     } finally {
//       setLoadingReport(false);
//     }
//   };

//   fetchReports();
// }, [tab, loginUserID, CompanyID, reportPage]);


//   // Fetch received reports
//   useEffect(() => {
//   if (tab !== "receive") return;

//   const fetchReceiveReports = async () => {
//     setLoadingReceive(true);
//     setErrorReceive(null);
//     try {
//       const res = await axios.get(
//         `https://goelectronix.in/api/v1/keys/report?receiver_id=${loginUserID}&mode=1&company_id=${CompanyID}&page=${receivePage}&per_page=${rowsPerPage}`
//       );

//       setReceivedReports(res.data.data || []);
//       setReceiveTotalPages(res.data.meta?.last_page || 1);
//     } catch (err) {
//       console.error("Failed to fetch receive reports:", err);
//       setErrorReceive("Failed to load receive report");
//     } finally {
//       setLoadingReceive(false);
//     }
//   };

//   fetchReceiveReports();
// }, [tab, loginUserID, CompanyID, receivePage]);


//   // Fetch retailers
//   useEffect(() => {
//     if (!loginUserID) return;
//     axios
//       .get(
//         `https://goelectronix.in/api/v1/get-allretailers2?page=1&per_page=${rowsPerPage}&distributortID=${loginUserID}`
//       )
//       .then((res) => {
//         const data = res.data.data.data || [];
//         setRetailers(data);
//       })
//       .catch((err) => console.error(err));
//   }, [loginUserID]);

//   // Fetch packages
//   useEffect(() => {
//     if (!loginUserID) return;
//     axios
//       .get(
//         `https://goelectronix.in/api/v1/keys/all-my-package-list?receiver_id=${loginUserID}`
//       )
//       .then((res) => setPackages(res.data.data || []))
//       .catch((err) => console.error(err));
//   }, [loginUserID]);

//   // Auto-calculate total
//   useEffect(() => {
//     const total = parseInt(numKeys || 0) * parseFloat(keyRate || 0);
//     setTotalAmount(isNaN(total) ? "" : total.toFixed(2));
//   }, [numKeys, keyRate]);

//   const handleAssign = async () => {
//     const selectedPkg = packages.find((pkg) => pkg.package_name === packageType);
//     if (!selectedPkg) {
//       Swal.fire("Error", "Please select a package", "error");
//       return;
//     }

//     const selectedRetailerData = retailers.find((ret) => ret.ID === selectedRetailer);
//     if (!selectedRetailerData) {
//       Swal.fire("Error", "Please select a retailer", "error");
//       return;
//     }

//     const payload = {
//       sender_id: authUser?.id,
//       sender_name: authUser?.business_name,
//       sender_code: authUser?.org_code,
//       receiver_name: selectedRetailerData.Shop_Name,
//       receiver_code: selectedRetailerData.RetailerCode,
//       receiver_id: selectedRetailerData.USerID,
//       package_name: selectedPkg.package_name,
//       key_rate: keyRate,
//       qty: numKeys,
//       amount: totalAmount,
//       product_id: selectedPkg.product_id,
//       key_type: selectedPkg.key_type,
//       mode: 1,
//       company_id: 5865,
//       dist_id: authUser?.id,
//       role: selectedRetailerData.Role,
//       user_package_id: selectedPkg.id,
//       created_by_id: authUser?.id,
//       created_by_name: authUser?.business_name,
//       created_by_code: authUser?.org_code,
//       sender_package_id: selectedPkg.id,
//       customer_id: selectedRetailerData.contact_id?.toString(),
//       bill_type: "Rebilling",
//       is_warranty: selectedPkg.is_warranty,
//     };

//     Swal.fire({
//       title: `Assigning keys to ${selectedRetailerData.Shop_Name}...`,
//       text: "Please wait",
//       allowOutsideClick: false,
//       didOpen: () => Swal.showLoading(),
//     });

//     try {
//       await axios.post(
//         "https://goelectronix.in/api/v1/keys/assign-without-zoho",
//         payload
//       );
//       Swal.fire(
//         "Success ✅",
//         `Keys assigned successfully to ${selectedRetailerData.Shop_Name}`,
//         "success"
//       );

//       setPackageType("");
//       setNumKeys("");
//       setKeyRate("");
//       setTotalAmount("");
//       setSelectedRetailer("");
//       setAgree(false);
//     } catch (err) {
//       console.error(err);
//       Swal.fire("Error ❌", "Failed to assign keys. Please try again.", "error");
//     }
//   };

//   const paginate = (array, page) =>
//     array.slice((page - 1) * rowsPerPage, page * rowsPerPage);

//   const totalReceivePages = Math.ceil(receivedReports.length / rowsPerPage);
//   const totalReportPages = Math.ceil(assignedReports.length / rowsPerPage);
//   const totalBalancePages = Math.ceil(retailers.length / rowsPerPage);


//   // Filter package list by keyType
//   const filteredPackages = packages.filter((pkg) => {
//     if (keyType === "Regular") return pkg.key_type === 1;
//     if (keyType === "Smart") return pkg.key_type === 2;
//     return false;
//   });

//   return (
//     <div className="space-y-3 sm:space-y-4">
//       <Header title="Keys">
//         <div className="flex flex-wrap gap-2 text-xs sm:text-sm">
//           <TabButton
//             active={tab === "assign"}
//             onClick={() => setTab("assign")}
//             className="flex items-center gap-1"
//           >
//             {/* Icon only visible on small screens */}
//             <KeyRound className="w-4 h-4 sm:hidden" />
//             {/* Text only visible on sm+ screens */}
//             <span className="hidden sm:inline">Assign</span>
//           </TabButton>

//           <TabButton
//             active={tab === "receive"}
//             onClick={() => setTab("receive")}
//             className="flex items-center gap-1"
//           >
//             <Download className="w-4 h-4 sm:hidden" />
//             <span className="hidden sm:inline">Receive</span>
//           </TabButton>

//           <TabButton
//             active={tab === "report"}
//             onClick={() => setTab("report")}
//             className="flex items-center gap-1"
//           >
//             <FileText className="w-4 h-4 sm:hidden" />
//             <span className="hidden sm:inline">Assigned Report</span>
//           </TabButton>

//           <TabButton
//             active={tab === "retailer-balance"}
//             onClick={() => setTab("retailer-balance")}
//             className="flex items-center gap-1"
//           >
//             <Wallet className="w-4 h-4 sm:hidden" />
//             <span className="hidden sm:inline">Retailer Key Balance</span>
//           </TabButton>
//         </div>
//       </Header>



//       {tab === "assign" && (
//         <Card title="Assign Keys to Retailer">
//           <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
//             {/* Retailer Dropdown */}
//             <Select
//               options={retailers.map((ret) => ({
//                 value: ret.ID,
//                 label: `${ret.Shop_Name} - ${ret.RetailerCode}`,
//               }))}
//               value={
//                 retailers
//                   .map((ret) => ({
//                     value: ret.ID,
//                     label: `${ret.Shop_Name} - ${ret.RetailerCode}`,
//                   }))
//                   .find((opt) => opt.value === selectedRetailer) || null
//               }
//               onChange={(option) => setSelectedRetailer(option?.value || "")}
//               placeholder="Select Retailer..."
//               isClearable
//             />

//             {/* Key Type */}
//             <select
//               value={keyType}
//               onChange={(e) => {
//                 setKeyType(e.target.value);
//                 setPackageType("");
//               }}
//               className="rounded-lg border px-3 py-2 text-sm"
//             >
//               <option value="Smart">Smart</option>
//               <option value="Regular">Regular</option>
//             </select>

//             {/* Package Type */}
//             <select
//               value={packageType}
//               onChange={(e) => setPackageType(e.target.value)}
//               className="rounded-lg border px-3 py-2 text-sm"
//             >
//               <option value="">Select Package</option>
//               {filteredPackages.map((pkg) => (
//                 <option key={pkg.id} value={pkg.package_name}>
//                   {pkg.package_name} - {pkg.balance_keys}
//                 </option>
//               ))}
//             </select>

//             {/* Number of Keys */}
//             <input
//               type="number"
//               placeholder="Number of Keys"
//               value={numKeys}
//               onChange={(e) => {
//                 const value = parseInt(e.target.value || "0", 10);
//                 const selectedPkg = filteredPackages.find(
//                   (pkg) => pkg.package_name === packageType
//                 );
//                 const maxAllowed = selectedPkg ? selectedPkg.balance_keys : Infinity;
//                 if (value <= maxAllowed) {
//                   setNumKeys(e.target.value);
//                 } else {
//                   setNumKeys(maxAllowed.toString());
//                 }
//               }}
//               className="rounded-lg border px-3 py-2 text-sm"
//             />

//             {/* Key Rate */}
//             <input
//               type="number"
//               placeholder="Key Rate"
//               value={keyRate}
//               onChange={(e) => setKeyRate(e.target.value)}
//               className="rounded-lg border px-3 py-2 text-sm"
//             />

//             {/* Total Amount */}
//             <input
//               type="text"
//               placeholder="Total Amount"
//               value={totalAmount}
//               readOnly
//               className="rounded-lg border px-3 py-2 text-sm bg-gray-100"
//             />

//             {/* Submit button spanning both columns */}
//             <div className="sm:col-span-2 flex justify-end">
//               <BlueButton onClick={handleAssign}>Assign</BlueButton>
//             </div>
//           </div>
//         </Card>

//       )}

//       {tab === "receive" && (
//         <Card title="Received Keys Report (From Company)">
//           {loadingReceive ? <p>Loading...</p> :
//            errorReceive ? <p className="text-red-500">{errorReceive}</p> :
//            receivedReports.length === 0 ? <p>No data found</p> :
//            <>
//              <SimpleTable
//                 headers={[
//                   "Sr No.",
//                   "Date",
//                   "Sender (Code)",
//                   "Type",
//                   "Package",
//                   "Count",
//                   "Status",
//                 ]}
//                 rows={receivedReports.map((rep, i) => [
//                   (receivePage - 1) * rowsPerPage + i + 1,
//                   new Date(rep.created_at).toLocaleDateString(),
//                   `${rep.sender_name} (${rep.sender_code || "N/A"})`,
//                   rep.key_type === 1 ? "Regular" : "Smart",
//                   rep.package_name,
//                   rep.qty,
//                   <Badge label={"Received"} color={"blue"} />,
//                 ])}
//               />

//               {/* Pagination Controls */}
//               <div className="flex justify-center gap-2 mt-2">
//                 <button
//                   disabled={receivePage === 1}
//                   onClick={() => setReceivePage(receivePage - 1)}
//                   className="px-3 py-1 bg-gray-200 rounded disabled:opacity-50"
//                 >
//                   Prev
//                 </button>
//                 <span className="px-3 py-1">
//                   {receivePage} / {receiveTotalPages}
//                 </span>
//                 <button
//                   disabled={receivePage === receiveTotalPages}
//                   onClick={() => setReceivePage(receivePage + 1)}
//                   className="px-3 py-1 bg-gray-200 rounded disabled:opacity-50"
//                 >
//                   Next
//                 </button>
//               </div>
//            </>
//           }
//         </Card>
//       )}

//       {tab === "report" && (
//         <Card title="Assigned Keys Report">
//           {loadingReport ? <p>Loading...</p> :
//            errorReport ? <p className="text-red-500">{errorReport}</p> :
//            assignedReports.length === 0 ? <p>No data found</p> :
//            <>
//              <SimpleTable
//                 headers={["Sr No.","Date","Retailer (Code)","Type","Package","Count","Status"]}
//                 rows={assignedReports.map((rep, i) => [
//                   (reportPage - 1) * rowsPerPage + i + 1,
//                   new Date(rep.created_at).toLocaleDateString(),
//                   `${rep.receiver_name} (${rep.receiver_code || "N/A"})`,
//                   rep.key_type === 1 ? "Regular" : "Smart",
//                   rep.package_name,
//                   rep.qty,
//                   <Badge label={"Assigned"} color={"blue"} />,
//                 ])}
//               />

//               <div className="flex justify-center gap-2 mt-2">
//                 <button disabled={reportPage === 1} onClick={() => setReportPage(reportPage - 1)}>Prev</button>
//                 <span>{reportPage}/{reportTotalPages}</span>
//                 <button disabled={reportPage === reportTotalPages} onClick={() => setReportPage(reportPage + 1)}>Next</button>
//               </div>

//            </>
//           }
//         </Card>
//       )}

//       {tab === "retailer-balance" && (
//         <Card title="Retailer Key Balance">
//           <SimpleTable
//             headers={["Retailer (Code)","Regular Keys","Smart Keys","Total"]}
//             rows={paginate(retailers,balancePage).map((ret,i)=>{
//               const regular=parseInt(ret.regularPolicy||0,10);
//               const smart=parseInt(ret.smartPolicy||0,10);
//               return [`${ret.Shop_Name} (${ret.RetailerCode})`,regular,smart,regular+smart]
//             })}
//           />
//           <div className="flex justify-center gap-2 mt-2">
//             <button disabled={balancePage===1} onClick={()=>setBalancePage(balancePage-1)}>Prev</button>
//             <span>{balancePage}/{totalBalancePages}</span>
//             <button disabled={balancePage===totalBalancePages} onClick={()=>setBalancePage(balancePage+1)}>Next</button>
//           </div>
//         </Card>
//       )}

//     </div>
//   );
// }



// import { useState, useEffect } from "react";
// import axios from "axios";
// import Header from "../components/Header";
// import TabButton from "../components/TabButton";
// import Card from "../components/Card";
// import BlueButton from "../components/BlueButton";
// import SimpleTable from "../components/SimpleTable";
// import Badge from "../components/Badge";
// import Select from "react-select";

// export default function Keys() {
//   const [tab, setTab] = useState("assign");
//   const [keyType, setKeyType] = useState("Smart");
//   const [packageType, setPackageType] = useState("");
//   const [numKeys, setNumKeys] = useState("");
//   const [keyRate, setKeyRate] = useState("");
//   const [totalAmount, setTotalAmount] = useState("");
//   const [selectedRetailer, setSelectedRetailer] = useState("");
//   const [retailers, setRetailers] = useState([]);
//   const [packages, setPackages] = useState([]);
//   const [agree, setAgree] = useState(false);

//   const authUserString = sessionStorage.getItem("authUserData");
//   const authUser = JSON.parse(authUserString);
//   const loginUserID = authUser?.id;
//   console.log("senior id:", loginUserID);

//   // Fetch retailers
//   useEffect(() => {
//     axios
//       .get(
//         `https://goelectronix.in/api/v1/get-allretailers2?page=1&Senior_id=${loginUserID}`
//       )
//       .then((res) => {
//         const data = res.data.data.data || [];
//         setRetailers(data);
//       })
//       .catch((err) => {
//         console.error("Failed to fetch retailers", err);
//       });
//   }, [loginUserID]);

//   // Fetch packages
//   useEffect(() => {
//     axios
//       .get(
//         `https://goelectronix.in/api/v1/keys/all-my-package-list?receiver_id=${loginUserID}`
//       )
//       .then((res) => {
//         const data = res.data.data || [];
//         setPackages(data);
//       })
//       .catch((err) => {
//         console.error("Failed to fetch packages", err);
//       });
//   }, [loginUserID]);

//   // Auto-calculate total
//   useEffect(() => {
//     const total = parseInt(numKeys || 0) * parseFloat(keyRate || 0);
//     setTotalAmount(isNaN(total) ? "" : total.toFixed(2));
//   }, [numKeys, keyRate]);

//   const handleAssign = () => {
//     if (!agree) {
//       alert("Please agree to the terms and conditions.");
//       return;
//     }

//     const payload = {
//       keyType,
//       packageType,
//       numKeys,
//       keyRate,
//       totalAmount,
//       selectedRetailer,
//     };

//     console.log("Submitting payload:", payload);
//     // Submit logic
//   };

//   // Filter package list by keyType
//   const filteredPackages = packages.filter((pkg) => {
//     if (keyType === "Regular") return pkg.key_type === 1;
//     if (keyType === "Smart") return pkg.key_type === 2;
//     return false;
//   });

//   return (
//     <div className="space-y-3 sm:space-y-4">
//       <Header title="Keys">
//         <div className="flex gap-2 text-xs sm:text-sm">
//           <TabButton
//             active={tab === "assign"}
//             onClick={() => setTab("assign")}
//           >
//             Assign
//           </TabButton>
//           <TabButton
//             active={tab === "receive"}
//             onClick={() => setTab("receive")}
//           >
//             Receive
//           </TabButton>
//           <TabButton
//             active={tab === "report"}
//             onClick={() => setTab("report")}
//           >
//             Assigned Report
//           </TabButton>
//           <TabButton
//             active={tab === "retailer-balance"}
//             onClick={() => setTab("retailer-balance")}
//           >
//             Retailer Key Balance
//           </TabButton>
//         </div>
//       </Header>

//       {tab === "assign" && (
//         <Card title="Assign Keys to Retailer">
//           <div className="grid grid-cols-1 gap-3 sm:grid-cols-6">
//             {/* Key Type */}
//             <select
//               value={keyType}
//               onChange={(e) => {
//                 setKeyType(e.target.value);
//                 setPackageType(""); // reset package when type changes
//               }}
//               className="rounded-lg border px-3 py-2 text-sm"
//             >
//               <option value="Smart">Smart</option>
//               <option value="Regular">Regular</option>
//             </select>

//             {/* Package Type (from API) */}
//             <select
//               value={packageType}
//               onChange={(e) => setPackageType(e.target.value)}
//               className="rounded-lg border px-3 py-2 text-sm"
//             >
//               <option value="">Select Package</option>
//               {filteredPackages.map((pkg) => (
//                 <option key={pkg.id} value={pkg.package_name}>
//                   {pkg.package_name} - {pkg.balance_keys}
//                 </option>
//               ))}
//             </select>

//             {/* Number of Keys */}
//             {/* Number of Keys */}
//             <input
//               type="number"
//               placeholder="Number of Keys"
//               value={numKeys}
//               onChange={(e) => {
//                 const value = parseInt(e.target.value || "0", 10);

//                 // Find selected package
//                 const selectedPkg = filteredPackages.find(
//                   (pkg) => pkg.package_name === packageType
//                 );

//                 const maxAllowed = selectedPkg ? selectedPkg.balance_keys : Infinity;

//                 if (value <= maxAllowed) {
//                   setNumKeys(e.target.value);
//                 } else {
//                   // prevent typing more than available
//                   setNumKeys(maxAllowed.toString());
//                 }
//               }}
//               className="rounded-lg border px-3 py-2 text-sm"
//             />


//             {/* Key Rate */}
//             <input
//               type="number"
//               placeholder="Key Rate"
//               value={keyRate}
//               onChange={(e) => setKeyRate(e.target.value)}
//               className="rounded-lg border px-3 py-2 text-sm"
//             />

//             {/* Total Amount */}
//             <input
//               type="text"
//               placeholder="Total Amount"
//               value={totalAmount}
//               readOnly
//               className="rounded-lg border px-3 py-2 text-sm bg-gray-100"
//             />

//             {/* Retailer Dropdown */}
//             <Select
//               options={retailers.map((ret) => ({
//                 value: ret.ID,
//                 label: `${ret.Shop_Name} - ${ret.RetailerCode}`,
//               }))}
//               value={
//                 retailers
//                   .map((ret) => ({
//                     value: ret.ID,
//                     label: `${ret.Shop_Name} - ${ret.RetailerCode}`,
//                   }))
//                   .find((opt) => opt.value === selectedRetailer) || null
//               }
//               onChange={(option) => setSelectedRetailer(option?.value || "")}
//               placeholder="Select Retailer..."
//               isClearable
//             />

//             {/* Checkbox */}
//             <div className="sm:col-span-6 flex items-center space-x-2 mt-2">
//               <input
//                 type="checkbox"
//                 checked={agree}
//                 onChange={() => setAgree(!agree)}
//               />
//               <label className="text-sm">Agree to terms and conditions</label>
//             </div>

//             {/* Submit */}
//             <div className="sm:col-span-6 flex justify-end">
//               <BlueButton onClick={handleAssign}>Assign</BlueButton>
//             </div>
//           </div>
//         </Card>
//       )}

//       {tab === "receive" && (
//         <Card title="Receive Keys from Company">
//           <div className="grid grid-cols-1 gap-3 sm:grid-cols-5">
//             <select className="rounded-lg border px-3 py-2 text-sm">
//               <option value="regular">Regular</option>
//               <option value="smart">Smart</option>
//             </select>
//             <input placeholder="GRN / Reference No" className="rounded-lg border px-3 py-2 text-sm" />
//             <input placeholder="Start Key" className="rounded-lg border px-3 py-2 text-sm" />
//             <input placeholder="End Key" className="rounded-lg border px-3 py-2 text-sm" />
//             <div className="flex items-center justify-end">
//               <BlueButton>Receive</BlueButton>
//             </div>
//           </div>
//         </Card>
//       )}

//       {tab === "report" && (
//         <Card title="Assigned Keys Report (Retailer Code & Name)">
//           <SimpleTable
//             headers={["Sr No.","Date", "Retailer (Code)", "Type", "Package", "Range", "Count", "Status"]}
//             rows={[
//               ["1","2025-09-22", "Maha Mobile Hub (RT-1001)", "Regular", "Regular + Warranty", "GE-1000…GE-1030", "31", Badge("Completed")],
//               ["2","2025-09-21", "Ganesh Telecom (RT-1002)", "Smart", "Smart Key", "GE-0900…GE-0925", "26", Badge("Pending", "red")],
//             ]}
//           />
//         </Card>
//       )}

//       {tab === "retailer-balance" && (
//         <Card title="Retailer Key Balance (Regular & Smart)">
//           <SimpleTable
//             headers={["Retailer (Code)", "Regular Keys", "Smart Keys", "Total"]}
//             rows={[
//               ["Maha Mobile Hub (RT-1001)", "120", "86", "206"],
//               ["Ganesh Telecom (RT-1002)", "44", "21", "65"],
//               ["Sai Krupa (RT-1003)", "0", "0", "0"],
//             ]}
//           />
//         </Card>
//       )}
//     </div>
//   );
// }



// import { useState } from "react";
// import Header from "../components/Header";
// import TabButton from "../components/TabButton";
// import Card from "../components/Card";
// import BlueButton from "../components/BlueButton";
// import SimpleTable from "../components/SimpleTable";
// import Badge from "../components/Badge";

// export default function Keys() {
//   const [tab, setTab] = useState("assign"); // 'assign' | 'report' | 'receive' | 'retailer-balance'
//   return (
//     <div className="space-y-3 sm:space-y-4">
//       <Header title="Keys">
//         <div className="flex gap-2 text-xs sm:text-sm">
//           <TabButton active={tab === "assign"} onClick={() => setTab("assign")}>Assign</TabButton>
//           <TabButton active={tab === "receive"} onClick={() => setTab("receive")}>Receive</TabButton>
//           <TabButton active={tab === "report"} onClick={() => setTab("report")}>Assigned Report</TabButton>
//           <TabButton active={tab === "retailer-balance"} onClick={() => setTab("retailer-balance")}>Retailer Key Balance</TabButton>
//         </div>
//       </Header>

//       {tab === "assign" && (
//         <Card title="Assign Keys to Retailer">
//           <div className="grid grid-cols-1 gap-3 sm:grid-cols-6">
//             <input placeholder="Retailer ID / Code" className="rounded-lg border px-3 py-2 text-sm" />
//             <input placeholder="Retailer Name" className="rounded-lg border px-3 py-2 text-sm" />
//             <select className="rounded-lg border px-3 py-2 text-sm">
//               <option value="regular">Regular</option>
//               <option value="smart">Smart</option>
//             </select>
//             <select className="rounded-lg border px-3 py-2 text-sm">
//               <option>Regular Key</option>
//               <option>Regular + Warranty</option>
//               <option>Smart Key</option>
//             </select>
//             <input placeholder="Start Key (e.g., GE-1000)" className="rounded-lg border px-3 py-2 text-sm" />
//             <input placeholder="End Key (e.g., GE-1050)" className="rounded-lg border px-3 py-2 text-sm" />
//             <div className="sm:col-span-6 flex justify-end">
//               <BlueButton>Assign</BlueButton>
//             </div>
//           </div>
//         </Card>
//       )}

//       {tab === "receive" && (
//         <Card title="Receive Keys from Company">
//           <div className="grid grid-cols-1 gap-3 sm:grid-cols-5">
//             <select className="rounded-lg border px-3 py-2 text-sm">
//               <option value="regular">Regular</option>
//               <option value="smart">Smart</option>
//             </select>
//             <input placeholder="GRN / Reference No" className="rounded-lg border px-3 py-2 text-sm" />
//             <input placeholder="Start Key" className="rounded-lg border px-3 py-2 text-sm" />
//             <input placeholder="End Key" className="rounded-lg border px-3 py-2 text-sm" />
//             <div className="flex items-center justify-end">
//               <BlueButton>Receive</BlueButton>
//             </div>
//           </div>
//         </Card>
//       )}

//       {tab === "report" && (
//         <Card title="Assigned Keys Report (Retailer Code & Name)">
//           <SimpleTable
//             headers={["Date", "Retailer (Code)", "Type", "Package", "Range", "Count", "Status"]}
//             rows={[
//               ["2025-09-22", "Maha Mobile Hub (RT-1001)", "Regular", "Regular + Warranty", "GE-1000…GE-1030", "31", Badge("Completed")],
//               ["2025-09-21", "Ganesh Telecom (RT-1002)", "Smart", "Smart Key", "GE-0900…GE-0925", "26", Badge("Pending", "red")],
//             ]}
//           />
//         </Card>
//       )}

//       {tab === "retailer-balance" && (
//         <Card title="Retailer Key Balance (Regular & Smart)">
//           <SimpleTable
//             headers={["Retailer (Code)", "Regular Keys", "Smart Keys", "Total"]}
//             rows={[["Maha Mobile Hub (RT-1001)", "120", "86", "206"], ["Ganesh Telecom (RT-1002)", "44", "21", "65"], ["Sai Krupa (RT-1003)", "0", "0", "0"]]}
//           />
//         </Card>
//       )}
//     </div>
//   );
// }
